import React from 'react';
import B2BRoutesModule from '../b2b-common/B2BRoutesModule';
import MicroservicesExplorerPage from './pages/MicroservicesExplorerPage';

const systemRoutes = [
    { path: '/microservices-explorer', element: <MicroservicesExplorerPage />, visibility: 'private' },
    { path: '/*', element: <h1>Not Found</h1> }
];

const B2BSystem = () => {
    return <B2BRoutesModule routes={systemRoutes} />;
}

export default B2BSystem;